module.exports = __webpack_public_path__ + "202408221624/img/shengqi.c76992c4.png";